module.exports = __webpack_public_path__ + "static/img/login_bg.3b7951d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_bg.jpg
// module id = nLin
// module chunks = 1